import RevenueDealNode from "./RevenueDealNode"
import CommissionDealNode from "./CommissionDealNode"

const FlowNodes = (props) => {
    switch(props.type) {
        case 'revenuedeal': return <RevenueDealNode {...props} />;
        case 'commissiondeal': return <CommissionDealNode {...props} />;
        default: return <div></div>;
    }
}

export default FlowNodes;